import { useMemo } from 'react';
import { useGroupRules } from 'src/graphql';
import { CLIENT_TABS, ClientTab } from './client-const';

/**
 * The client tabs the current user is allowed to see, in display order.
 * See the note on `useSiteTabs` about why `loading` is exposed.
 */
export const useClientTabs = (): { tabs: ClientTab[]; loading: boolean } => {
  const { checkValidity, loading } = useGroupRules();

  const tabs = useMemo(
    () =>
      CLIENT_TABS.filter(
        (tab) =>
          !tab.allowedRules ||
          (!loading && checkValidity(tab.allowedRules, { matchType: 'any' })),
      ),
    [checkValidity, loading],
  );

  return { tabs, loading };
};
